import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCompanyCategory', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/company-categories/issue_form_category.html'),
        controller: 'IssueFormCompanyCategoriesController',
        controllerAs: 'IssueFormCompanyCategoriesCtrl',
        bindings: {
            isFullWidth: '<',
            companyId: '<',
            category: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/company-categories/issue_form_category.component.ts